/**
 * Season light (F4.2-f, R22): the farmer's season kg for the crop (roster) + his lots made on this
 * phone since the roster was downloaded + this delivery, against the ceiling from the roster.
 * Green or amber only — never a number on screen. No ceiling → amber (the server holds with
 * NO_CEILING, F4.10).
 */
export type SeasonLight = 'GREEN' | 'AMBER'

export function seasonLight(args: {
  seasonToDateG: number | null
  ceilingG: number | null
  todayOnPhoneG: number
  thisDeliveryG: number
}): SeasonLight {
  if (args.ceilingG === null) return 'AMBER'
  const total = (args.seasonToDateG ?? 0) + args.todayOnPhoneG + args.thisDeliveryG
  return total > args.ceilingG ? 'AMBER' : 'GREEN'
}
